import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { appStore } from '../stores/AppStore';
import DeviceCard from './DeviceCard';

interface DeviceListProps {
  onRefresh: () => void;
}

interface DeviceListPropsWithLogout extends DeviceListProps {
  onLogout?: () => void;
}

const DeviceList: React.FC<DeviceListPropsWithLogout> = observer(({ onRefresh, onLogout }) => {
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);

  const handleDeviceSelect = (device: any) => {
    appStore.setSelectedDevice(device);
  };

  const handleRenameDevice = (deviceId: string, newName: string) => {
    appStore.renameDevice(deviceId, newName);
  };

  const handleDeleteDevice = (deviceId: string) => {
    if (onLogout) {
      appStore.deleteCurrentDevice(deviceId, onLogout);
    }
  };

  return (
    <Card sx={{ backgroundColor: 'rgba(255, 255, 255, 0.12)', backdropFilter: 'blur(10px)' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ color: '#FFFFFF', fontWeight: 'bold' }}>
          Your Devices
        </Typography>
        
        {appStore.isLoadingDevices ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {/* Current device (web browser) - Always at top */}
            {appStore.currentDevice && (
              <DeviceCard
                key={appStore.currentDevice.id}
                device={appStore.currentDevice}
                isSelected={appStore.selectedDevice?.id === appStore.currentDevice.id}
                onClick={() => handleDeviceSelect(appStore.currentDevice)}
                onRename={handleRenameDevice}
                onDelete={handleDeleteDevice}
                isCurrentDevice={true}
                hasNewMessages={appStore.hasNewMessages}
              />
            )}
            
            {/* Other devices (excluding current device) */}
            {appStore.otherDevices.map((device) => (
              <DeviceCard
                key={device.id}
                device={device}
                isSelected={appStore.selectedDevice?.id === device.id}
                onClick={() => handleDeviceSelect(device)}
                isCurrentDevice={false}
              />
            ))}
          </Box>
        )}
        
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={onRefresh}
          sx={{ mt: 1 }}
          fullWidth
          disabled={appStore.isLoadingDevices}
        >
          Refresh Devices
        </Button>
      </CardContent>
    </Card>
  );
});

export default DeviceList;







